/**
 * Что очистить в приложении, когда запись Истории удалена (обращение владельца 10.10:
 * удалённая запись оставалась на экранах «Распознавание» и «Протокол»).
 *
 * Связь задача → запись живёт в historyLinks. Экран распознавания относится к записи,
 * если transcriptionState.taskId — ключ такой связи; протокол — если его sourceTaskId
 * такой ключ или standaloneItemId равен id записи.
 *
 * Связь убираем вместе с сбросом экрана, а не отдельно: эффекты автосохранения
 * идемпотентны именно по ней, и живое состояние без связи записало бы удалённое
 * заново. Поэтому ключи, за которыми стоит состояние другого экрана (АТС, поток),
 * приходят в keepKeys и остаются.
 */
export function planDeleteCleanup(id, { historyLinks, transcriptionState, protocolState, keepKeys = [] } = {}) {
  const links = historyLinks || {};
  const taskIds = Object.keys(links).filter((k) => links[k] === id);
  const resetTranscription = !!transcriptionState?.taskId && taskIds.includes(transcriptionState.taskId);
  const resetProtocol = !!protocolState && (
    (!!protocolState.sourceTaskId && taskIds.includes(protocolState.sourceTaskId))
    || protocolState.standaloneItemId === id
  );
  const drop = taskIds.filter((k) => !keepKeys.includes(k));
  if (!drop.length) return { resetTranscription, resetProtocol, nextLinks: links };
  const nextLinks = { ...links };
  drop.forEach((k) => { delete nextLinks[k]; });
  return { resetTranscription, resetProtocol, nextLinks };
}

/**
 * Вкладка после нажатия на корзину открытой записи: с «История» возвращаемся на
 * прежнюю, с любой другой остаёмся (открытая запись живёт и после ухода с вкладки).
 */
export function tabAfterItemDelete(activeTab, previousTab) {
  return activeTab === 'history' ? previousTab : activeTab;
}
